<template>
  <div>
    <div class="container-fluid p-t-40">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form class="form theme-form datepicker-responsive SupplierAdInfo">
          <AdListView
            v-if="!detailPayload"
            ref="listView"
            :companyId="supplierId"
            :fromAdmin="true"
            :embedded="true"
            @open-detail="openDetail"
            @adTabChange="onAdTabChange"
          />
          <AdDetailView
            v-else
            ref="detailView"
            :companyId="supplierId"
            :adDetailId="detailPayload.adDetailId"
            :adPackageId="detailPayload.adPackageId"
            :pcAdDetailId="detailPayload.pcAdDetailId"
            :pcAdPackageId="detailPayload.pcAdPackageId"
            :mobileAdDetailId="detailPayload.mobileAdDetailId"
            :mobileAdPackageId="detailPayload.mobileAdPackageId"
            :pageType="detailPayload.pageType"
            :listRow="detailPayload.row"
            :fromAdmin="true"
            :embedded="true"
            @open-detail="openDetail"
            @close-detail="closeDetail"
            @adTabChange="onAdTabChange"
          />
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import AdListView from '../../advertisingInfoCenter/AdListView.vue';
import AdDetailView from '../../advertisingInfoCenter/AdDetailView.vue';

export default {
  components: {
    AdListView,
    AdDetailView,
  },
  props: ['supplierId'],
  data() {
    return {
      detailPayload: null,
    };
  },
  watch: {
    supplierId() {
      this.detailPayload = null;
    },
  },
  methods: {
    openDetail(payload) {
      this.detailPayload = payload;
    },
    closeDetail() {
      this.detailPayload = null;
      this.$nextTick(() => {
        this.$refs.listView?.refresh();
      });
    },
    onAdTabChange(statusCode, isLaunchOnline) {
      this.$emit('adTabChange', statusCode, isLaunchOnline);
    },
    todoSave() {
      if (this.detailPayload) {
        return this.$refs.detailView?.todoSave();
      }
      return Promise.resolve(false);
    },
    refresh() {
      if (this.detailPayload) {
        return this.$refs.detailView?.refresh();
      }
      return this.$refs.listView?.refresh();
    },
    getAdDetails() {
      if (this.detailPayload) {
        return this.$refs.detailView?.getAdDetails() || [];
      }
      return [];
    },
    prepareAdApproval(intent) {
      if (this.detailPayload) {
        return this.$refs.detailView?.prepareAdApproval?.(intent)
          || Promise.resolve({ ok: false });
      }
      return Promise.resolve({ ok: false });
    },
  },
};
</script>

<style>
.SupplierAdInfo {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.SupplierAdInfo .ad-list-view,
.SupplierAdInfo .ad-detail-view {
  padding-left: 0 !important;
  padding-right: 0 !important;
  box-sizing: border-box;
}

.SupplierAdInfo .ad-detail-view:not(:has(.adPageCard--logo-wide)) {
  width: 100% !important;
  max-width: 100% !important;
}

.SupplierAdInfo .ad-detail-view--embedded {
  min-height: calc(100vh - 260px);
}

/* 参展商名单宽 logo：横向滚动放在内容区，标题栏保持吸顶 */
.SupplierAdInfo .ad-detail-view:has(.adPageCard--logo-wide) {
  overflow-x: visible;
  width: 100%;
  max-width: 100%;
}

.SupplierAdInfo .ad-detail-view:has(.adPageCard--logo-wide) .ad-detail-overlay {
  overflow-x: auto;
  width: 100% !important;
  max-width: 100% !important;
}

.SupplierAdInfo .ad-detail-view:has(.adPageCard--logo-wide) .ad-detail-overlay > .b-overlay-wrap {
  width: max-content !important;
  min-width: 100% !important;
  max-width: none !important;
}

.SupplierAdInfo .ad-detail-view:not(:has(.adPageCard--logo-wide)) .ad-detail-card {
  width: 100% !important;
  max-width: 100% !important;
  align-self: stretch;
}

.SupplierAdInfo .ad-detail-view:has(.adPageCard--logo-wide) .ad-detail-card {
  width: max-content !important;
  min-width: 100% !important;
  max-width: none !important;
  align-self: stretch;
}

.R-StatusCode-Box {
  padding: 16px;
  background: #FFE6E6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.R-StatusCode-Box .R-StatusCode-Title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 16px;
  font-weight: 700;
  line-height: 20.80px;
  word-wrap: break-word;
  display: flex;
  gap: 8px;
  align-items: center;
}

.R-StatusCode-Box .R-StatusCode-Title i {
  color: #CD1515;
}

.R-StatusCode-Box .R-StatusCode-Desc {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
}
</style>
